import qs from 'qs';
import React, { FC } from 'react';
import { subMonths, subDays, subYears } from 'date-fns';
import { IconButton, Typography } from '@scope/scope-one-ui/core';
import MessageGrowth from 'assets/icons/message-growth.svg';
import X from 'assets/icons/x.svg';
import { formatDate } from '@scope/scope-one-ui/global/utils';
import { COLORS } from '@scope/scope-one-ui/theme';
import { useTranslation } from 'react-i18next';
import { Period } from '@scope/scope-one-ui/core/SentimentBar/SentimentBar.d';
import { SideButton, SidebarWrapper, Chevron, IframeWindow, Header } from './EventSidebar.styled';
import { EventSidebarProps } from './EventSidebar.d';

const sentifiUrl = 'https://intelligence.sentifi.com/cc/right-rail';
const sentifiToken = '9d65dab0-cca8-4b19-a38e-fc3876289864-a4c5d';

const getDates = (period: Period) => {
  const dateFormat = 'yyyy-MM-dd';
  const today = new Date();

  const startDates: Record<Period, string> = {
    '0day': formatDate(today, dateFormat),
    '7days': formatDate(subDays(today, 7), dateFormat),
    '1months': formatDate(subMonths(today, 1), dateFormat),
    '3months': formatDate(subMonths(today, 3), dateFormat),
    '6months': formatDate(subMonths(today, 6), dateFormat),
    '1year': formatDate(subYears(today, 1), dateFormat),
    max: '2015-01-01',
  };

  return {
    startDate: startDates[period],
    endDate: formatDate(today, dateFormat),
  };
};

export const EventSidebar: FC<EventSidebarProps> = ({
  topicId,
  eventId,
  period,
  loading,
  open,
  eventType,
  onToggle,
}) => {
  const { t } = useTranslation();
  const { startDate, endDate } = getDates(period);

  const params = qs.stringify(
    {
      token: sentifiToken,
      'topic-id': topicId,
      'start-date': startDate,
      'end-date': endDate,
      ...(eventId ? { 'event-id': eventId } : { 'esg-types': eventType.slice(0, 1) }),
    },
    { skipNulls: true },
  );

  return (
    <SidebarWrapper display="flex" alignItems="center" open={open}>
      <SideButton onClick={onToggle} variant={open ? 'secondary' : 'primary'} disabled={loading}>
        <MessageGrowth />
        <Chevron open={open} />
      </SideButton>
      <IframeWindow title="Events details" src={`${sentifiUrl}?${params}`} />
      <Header p={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h1" color={COLORS.typography.label}>
          {t('Events')}
        </Typography>
        <IconButton onClick={onToggle} size="small">
          <X />
        </IconButton>
      </Header>
    </SidebarWrapper>
  );
};
